<template>
  <el-container class="background-white">
    <el-header>
      <h1>Order Flow Status
        <el-button
          class="pull-right"
          type="primary"
          round @click="fetch"
          :disabled="loading">Refresh
        </el-button>
      </h1>
    </el-header>
    <el-main>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="Filter" name="filter">
          <el-col :span="12">
            <h3>Filter Missing</h3>
            <el-row>
              <el-col :span="8">
                <el-switch
                  v-model="missingD365"
                  active-text="D365"
                  inactive-text=""
                  :disabled="loading"
                  v-on:change="toggleHandler">
                </el-switch>
              </el-col>
              <el-col :span="8">
                <el-switch
                  v-model="missingFulfillment"
                  active-text="Fulfillment"
                  inactive-text=""
                  :disabled="loading"
                  v-on:change="toggleHandler">
                </el-switch>
              </el-col>
              <el-col :span="8">
                <el-switch
                  v-model="missingTracking"
                  active-text="Tracking"
                  inactive-text=""
                  :disabled="loading"
                  v-on:change="toggleHandler">
                </el-switch>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <h3>Date Range</h3>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="right"
              start-placeholder="Start Date"
              end-placeholder="End Date">
            </el-date-picker>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="Search" name="search">
          <el-col :span="16">
            <el-input
              v-model="orderId"
              placeholder="Shopify Order Id"
              size="medium">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="8" class="text-right">
            <el-button type="primary" size="small" icon="el-icon-search"
                       @click="searchHandler">Search
            </el-button>
          </el-col>
        </el-tab-pane>
      </el-tabs>
      <hr>
      <el-table v-loading="loading" :data="data.data">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row>
              <el-col :span="12"
                      v-if="props.row.errors && props.row.errors.length > 0">
                <h3>Errors</h3>
                <ol>
                  <li v-for="error in props.row.errors">
                    {{error.created_at | utcToLocal}}: {{error.message}}
                  </li>
                </ol>
              </el-col>
              <el-col :span="12" v-if="props.row.tracking">
                <h3>Warehouse Fulfillment</h3>
                <div><strong>Created</strong>:
                  {{props.row.tracking.created_at | utcToLocal}}
                </div>
                <div><strong>Report</strong>:
                  {{props.row.tracking.report.file_name}}
                </div>
                <div><strong>Status</strong>:
                  {{props.row.tracking.order_status}}
                </div>
                <div><strong>Carrier</strong>:
                  {{props.row.tracking.carrier_name}}
                </div>
                <div><strong>Tracking Code</strong>:
                  {{props.row.tracking.tracking_code}}
                </div>
              </el-col>
              <el-col :span="12" v-if="props.row.fulfillment">
                <h3>Shopify Fulfillment</h3>
                <div><strong>Created</strong>:
                  {{props.row.fulfillment.created_at | utcToLocal}}
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="Order Created At">
          <template slot-scope="props">
            {{props.row.created_at | utcToLocal}}
          </template>
        </el-table-column>
        <el-table-column label="Region" prop="region"/>
        <el-table-column label="Order ID" prop="order_id"/>
        <el-table-column label="Control Number" prop="control_number"/>
        <el-table-column label="Fulfilled At">
          <template slot-scope="props">
            {{props.row.fulfilled_at | utcToLocal}}
          </template>
        </el-table-column>
        <el-table-column label="Tracking Email Sent At">
          <template slot-scope="props">
            {{props.row.tracking_email_sent_at | utcToLocal}}
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <el-pagination
        background
        layout="prev, pager, next, ->, total"
        :page-size="Number(data.per_page)"
        :total="data.total"
        :page-count="data.last_page"
        :current-page="data.current_page"
        @current-change="currentChangeHandler"
        @size-change="sizeChangeHandler">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
  import moment from 'moment';
  import {RepositoryFactory} from '../../../repositories/RepositoryFactory';

  const OrderStatusRepository = RepositoryFactory.get('acadia/kitsilano/orders/order-status');

  export default {
    name: 'OrderStatusTable',
    created() {
      this.dateRange = [
        moment().subtract(4, 'weeks').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ];
      this.fetch();
    },
    data() {
      return {
        loading: true,
        data: {},
        sizes: [10, 20, 30, 40, 50],
        limit: 10,
        page: 1,
        activeTab: 'filter',
        missingD365: false,
        missingFulfillment: false,
        missingTracking: false,
        orderId: null,
        dateRange: [],
      };
    },
    methods: {
      async fetch() {
        this.loading = true;

        try {
          const {data} = await OrderStatusRepository.fetch(this.params);
          this.data = data;
          this.orderId = null;
        } catch (err) {
          this.$message.error(err.message || 'Error loading order status');
        } finally {
          this.loading = false;
        }
      },
      currentChangeHandler(page) {
        this.page = page;
        this.fetch();
      },
      sizeChangeHandler(limit) {
        this.limit = limit;
        this.fetch();
      },
      searchHandler() {
        this.fetch();
      },
      toggleHandler() {
        this.page = 1;
        this.fetch();
      },
    },
    computed: {
      params: function() {
        const params = {
          'page': this.page,
        };

        if (this.dateRange) {
          params['from'] = moment(this.dateRange[0]).format('YYYY-MM-DD');
          params['to'] = moment(this.dateRange[1]).format('YYYY-MM-DD');
        }

        if (this.missingD365) {
          params['missing-d365'] = this.missingD365;
        }

        if (this.missingFulfillment) {
          params['missing-fulfillment'] = this.missingFulfillment;
        }

        if (this.missingTracking) {
          params['missing-tracking'] = this.missingTracking;
        }

        if (this.orderId) {
          params['order_id'] = this.orderId;
        }

        return params;
      },
    },
    filters: {
      utcToLocal: function(value) {
        if (!value) {
          return '';
        }

        return moment.utc(value).local().format('YYYY-MM-DD hh:mm:ss');
      },
    },
  };
</script>
